import { styled } from "@mui/material/styles";

export const Wrapper = styled("div")(({ theme }) => ({
    display: "grid",
    gridTemplateAreas: '"title price"',
    gridTemplateColumns: "auto min-content",
    gap: theme.spacing(2, 1),
}));

export const TitleWrapper = styled("div")(() => ({
    gridArea: "title",
    alignSelf: "start",
    display: "flex",
    flexDirection: "column",
}));

export const PriceAndAvailability = styled("div")(({ theme }) => ({
    gridArea: "price",
    whiteSpace: "nowrap",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
    display: "none",
    [theme.breakpoints.down("lg")]: {
        alignSelf: "start",
    },
    [theme.breakpoints.up("sm")]: {
        display: "flex",
    },
}));
